var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"site-footer"},[_c('div',{staticClass:"container-fluid"},[_c('p',{staticClass:"rc-copy",domProps:{"innerHTML":_vm._s(_vm.copy)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }